.page {
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 960px;
}

.title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  font-stretch: 116%;
  letter-spacing: -0.035em;
  line-height: 1;
}

.heading {
  margin-bottom: 12px;
  font-size: 1.125rem;
  font-weight: 650;
}

.note {
  color: var(--text-secondary);
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid var(--border-primary);
}

.table tr {
  border-bottom: 1px solid var(--border-subtle);
}

.table th,
.table td {
  padding: 16px 12px 16px 0;
  text-align: left;
  vertical-align: middle;
}

.cellName {
  font-weight: 600;
  width: 28%;
}

.detail {
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  color: var(--text-muted);
}
